import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Floor
{
    constructor(shadowOpacity)
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources

        this.setGeometry()
        this.setMaterial()
        this.setMesh()
    }

    setGeometry()
    {
        this.geometry = new THREE.CircleGeometry(1000, 10)
    }

   

    setMaterial()
    {
        this.material = new THREE.ShadowMaterial({
            opacity:0.3,
            transparent:true,
            color:"f0f0f0"
        })
    }

    setMesh()
    {
            
        this.mesh = new THREE.Mesh(this.geometry, this.material)
      



            this.resources=this.experience.resources;
            console.log(this.resources);
            this.resource=this.resources.items.object
            this.model=this.resource.scene
            const bbox = new THREE.Box3().setFromObject(this.model);
           
            const center = new THREE.Vector3();
            const size = new THREE.Vector3();
            bbox.getCenter(center);
            bbox.getSize(size);
            const planeHeight = bbox.min.y // Adjust the value as needed
            this.mesh.position.copy(center);
            this.mesh.position.y = planeHeight-0.65;
          


            this.mesh.rotation.x = - Math.PI * 0.5
            this.mesh.receiveShadow = true
            this.scene.add(this.mesh)
       
       
    }
}